export interface CatalogAdjustmentReason {
	AdjustmentReasonId: number | null;
	AdjustmentReasonName: string;
	IsActive: boolean;
}

export const ADJUSTMENT_REASON_INITIAL_VALUES: CatalogAdjustmentReason = {
	AdjustmentReasonId: null,
	AdjustmentReasonName: "",
	IsActive: true,
};
